import { createTheme, PaletteOptions, ThemeOptions, ThemeProvider } from '@mui/material';
import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import './App.css';
import Dashboard from './dashboard/Dashboard';
import ForgotPassword from './account/ForgotPassword';
import IdVerify from './profile/IdVerify';
import Login from './account/Login';
import Profile from './profile/Profile';
import ResetPassword from './account/ResetPassword';
import Signup from './account/Signup';
import { Snaxbar } from './Snaxbar';
import VideoApp from './video/VideoApp';
import PrivateRoute from './video/components/PrivateRoute/PrivateRoute';
import Admin from './admin/Admin';
import Series from './series/Series';

const theme = createTheme({
  palette: {
    primary: {
      main: '#f78069',
      contrastText: "#fff"
    } as unknown as PaletteOptions,
    secondary: {
      main: '#44949d',
      contrastText: "#fff"
    }
  } as unknown as PaletteOptions
} as unknown as ThemeOptions);

function App() {
  return (
    <div style={{
      height: '100vh',
    }}>
      <ThemeProvider theme={theme}>
        <Snaxbar />
        <Routes>
          <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/dashboard/:guid" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/series" element={<PrivateRoute><Series /></PrivateRoute>} />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Login />} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/reset" element={<ResetPassword />} />
          <Route path="/room/:guid" element={<PrivateRoute><VideoApp /></PrivateRoute>} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify" element={<PrivateRoute><IdVerify /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
        <footer
          style={{
            bottom: 0,
            fontSize: 8,
            marginRight: 8,
            position: 'fixed',
            right: 0,
          }}
        >Copyright © 2023 {process.env.REACT_APP_DOMAIN === 'sessionsfirst' ? 'Sessions' : 'PeerState'} All Rights Reserved.</footer>
      </ThemeProvider>
    </div>
  );
}

export default App;
